import { Button } from './button';
import { ProductTypes } from '../../shared/api-models/admin/product-types';

export class ProductCard {
	button: Button;
	productType: ProductTypes;
	hasContract: number;
	imagePath: string;
}